import { useCallback } from 'react';
import { createShipment, updateShipment } from '../services/api';
import { extractErrorMessage, createErrorMessageBoxConfig } from '../utils/errorHandler';

export const useFieldUpdates = (
  shipmentNumber,
  isNew,
  formData,
  setFormData,
  setMessageBoxConfig,
  setShowMessageBox,
  fieldNamesTranslations
) => {
  const updateField = useCallback(
    async (field, value) => {
      if (isNew) {
        // Pour un nouveau dossier, on met à jour seulement le formData local
        setFormData(prevFormData => ({
          ...prevFormData,
          [field]: value,
        }));
        return { status: 200 };
      }

      const updatedFormData = {
        shipment_number: shipmentNumber,
        [field]: value,
      };

      try {
        const response = await updateShipment(updatedFormData);
        if (response.status === 200) {
          setFormData(prevFormData => ({
            ...prevFormData,
            [field]: value,
          }));
        }
        return response;
      } catch (error) {
        const errorConfig = createErrorMessageBoxConfig(error, () => setShowMessageBox(false));
        setMessageBoxConfig({
          ...errorConfig,
          message: `Erreur lors de la mise à jour du champ ${
            fieldNamesTranslations[field] || field
          }: ${extractErrorMessage(error)}`,
        });
        setShowMessageBox(true);
        throw error;
      }
    },
    [
      shipmentNumber,
      isNew,
      setFormData,
      setMessageBoxConfig,
      setShowMessageBox,
      fieldNamesTranslations,
    ]
  );

  const updateForm = useCallback(
    async updatedFormData => {
      if (isNew) {
        try {
          const response = await createShipment(updatedFormData);
          if (response.status === 201) {
            return response;
          }
        } catch (error) {
          throw error;
        }
      } else {
        try {
          const response = await updateShipment(updatedFormData);
          if (response.status === 200) {
            return response;
          }
        } catch (error) {
          throw error;
        }
      }
    },
    [isNew]
  );

  return {
    updateField,
    updateForm,
  };
};
